import { API_ROOT } from 'packages/http_client/utils/constants';
import { VentureBuildersQuery } from '../types';

export const VENTURE_BUILDER_API = `${API_ROOT}/venturebuilder`;

export const MANAGED_STARTUP_API = `${API_ROOT}/venturebuildermanagedstartup`;

export const CREATE_VENTURE_BUILDER_API = '/api/venture-builder/';

export const VENTURE_BUILDER_QUERY_KEYS = {
  all: ['ventureBuilders'],
  list: (query: VentureBuildersQuery) => ['ventureBuilders', 'list', query],
  details: (id: number) => ['ventureBuilders', 'details', id],
  startups: (id: number) => ['ventureBuilders', 'startups', id],
};

export const MANAGED_STARTUP_NAME_MAX_LENGTH = 255;

// PM-confirmed allocation for each newly created managed startup; never a shared VB budget.
export const MANAGED_STARTUP_INITIAL_ALLOCATION = 40000;
